import {createFileRoute} from '@tanstack/react-router';
import {PurchaseListPage} from '../../../features/one-time-credit/pages/PurchaseListPage/PurchaseListPage';

export const Route = createFileRoute('/_protected/home/purchases')({
  component: PurchaseListPage,
  staticData: {crumbKey: 'navigation.purchases'},
});
